'use strict';

function PromoCode() {
  this.cookie = 'promoData';

  this.urls = {
    enter_code: '/dm/offer',
    view_offer: '/dm/offer-signup',
    opt_out: '/dm/offer-opt-out',
    opt_out_confirmed: '/dm/offer-opt-out-confirmed'
  };

  this.exists = function (model) {
    return !!model.promo_code;
  };

  this.get = function () {
    var data = Cookies.getJSON(this.cookie);
    if (typeof data === 'undefined') return false;

    // This is basically the less reliable way of doing `moment.utc(data.expiration_date)`...
    var timeObject = new TimeUtils();
    timeObject.nowDateObj = new Date(data.expiration_date);
    var normalizedDate = timeObject.getDestinationTime(0);

    if (data.payments.length == 1) {
      data.product_name = data.payments[0].name;
      data.payment_amount = data.payments[0].payments[0].biweekly;
    } else if (data.payments.length > 1) {
      data.product_name = 'money';
    }

    data.formatted_date = moment(normalizedDate).format('MMM D, YYYY');
    data.pre_approval_amount = parseInt(data.liquid_offer_amount || 0) + parseInt(data.mini_offer_amount || 0) + parseInt(data.zip_offer_amount || 0);

    return data;
  };

  this.save = function (data, expiryParam) {
    var expiryDays = 30;

    // NOTE: The stub returns current time, meaning it's instantly expired
    // Check to see whether the optional expiryParam parameter has been defined...
    Cookies.set(this.cookie, data, { expires: expiryParam ? new Date(expiryParam) : expiryDays });
  };

  this.delete = function () {
    Cookies.remove(this.cookie, { path: '/' });
  };
}